module.exports = __webpack_public_path__ + "static/media/infoDisplay.f9823c8c.png";